import { render, staticRenderFns } from "./PetsAllowedIconComp.vue?vue&type=template&id=97468b04&"
import script from "./PetsAllowedIconComp.vue?vue&type=script&lang=js&"
export * from "./PetsAllowedIconComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97468b04')) {
      api.createRecord('97468b04', component.options)
    } else {
      api.reload('97468b04', component.options)
    }
    module.hot.accept("./PetsAllowedIconComp.vue?vue&type=template&id=97468b04&", function () {
      api.rerender('97468b04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Ob52oKKH6kr9/JS/comp/PetsAllowedIconComp.vue"
export default component.exports